import { getCompanyDatasetLabel } from "./companyDetail";

const COMPANY_EDIT_OMITTED_KEYS = new Set([
  "company_summary",
  "source_count",
  "sources",
  "manual_entries",
  "delete",
]);

const normalizeCompanyTextList = (values) =>
  (Array.isArray(values) ? values : [])
    .map((value) => String(value || "").trim())
    .filter(Boolean);

const buildManualEntryKey = (collectionName, sourceId) =>
  `${String(collectionName || "").trim()}::${String(sourceId || "").trim()}`;

const buildCompanySourceGroupSummary = (record) => {
  const sources = Array.isArray(record?.sources) ? record.sources : [];
  const manualEntries = Array.isArray(record?.manual_entries) ? record.manual_entries : [];
  const manualEntryMap = new Map(
    manualEntries
      .map((entry) => {
        const id = String(entry?.id || "").trim();
        const collectionName = String(entry?.collection_name || "").trim();
        if (!id || !collectionName) {
          return null;
        }

        return [
          buildManualEntryKey(collectionName, id),
          {
            id,
            collectionName,
            insertedAt: entry?.inserted_at || null,
          },
        ];
      })
      .filter(Boolean)
  );

  const groupMap = new Map();

  sources.forEach((sourceEntry) => {
    const datasetKey = String(sourceEntry?.dataset || "").trim();
    const collectionName = String(sourceEntry?.collection_name || "").trim();
    const sourceIds = normalizeCompanyTextList(sourceEntry?.source_doc_ids);

    if (!datasetKey || !sourceIds.length) {
      return;
    }

    const currentGroup = groupMap.get(datasetKey) || {
      datasetKey,
      label: getCompanyDatasetLabel(datasetKey),
      docs: 0,
      items: [],
    };
    const itemMap = currentGroup._itemMap || new Map();

    sourceIds.forEach((recordId) => {
      const existingItem = itemMap.get(recordId);
      const manualEntry = manualEntryMap.get(buildManualEntryKey(collectionName, recordId)) || null;
      const isManual = Boolean(manualEntry);
      if (existingItem) {
        existingItem.removable = existingItem.removable || isManual;
        if (manualEntry && !existingItem.manualEntry) {
          existingItem.manualEntry = manualEntry;
        }
        return;
      }

      const nextItem = {
        recordId,
        label: recordId,
        collectionName,
        removable: isManual,
        manualEntry,
      };
      itemMap.set(recordId, nextItem);
      currentGroup.items.push(nextItem);
    });

    currentGroup.docs = currentGroup.items.length;
    currentGroup._itemMap = itemMap;
    groupMap.set(datasetKey, currentGroup);
  });

  return Array.from(groupMap.values())
    .map(({ _itemMap, ...group }) => ({
      ...group,
      ids: group.items.map((item) => item.recordId),
    }))
    .sort((left, right) => {
      if (right.docs !== left.docs) {
        return right.docs - left.docs;
      }
      return left.label.localeCompare(right.label);
    });
};

const parseCompanySourceIdList = (rawValue) =>
  String(rawValue || "")
    .split(/[\n,]+/)
    .map((item) => item.trim())
    .filter(Boolean);

export {
  COMPANY_EDIT_OMITTED_KEYS,
  buildCompanySourceGroupSummary,
  normalizeCompanyTextList,
  parseCompanySourceIdList,
};
